module.exports = __webpack_public_path__ + "img/tongtool-logo.40a4f372.png";